module.exports = __webpack_public_path__ + "static/img/manufacturerManage.f5f91e56.png";